export default __webpack_public_path__ + "static/media/predictiveupload.1b954546.svg";